<template>
  <div>
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
    <div
      class="drop"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      @click="handleUpload"
    >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <a>
              <v-icon class="mx-auto" elevation="3" size="50" color="primary">
                mdi-file-plus-outline
              </v-icon>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            {{
              $vuetify.lang.t(
                '$vuetify.learnerManagement.importUsersDialog.dragFile1'
              )
            }}
            <a>
              {{
                $vuetify.lang.t(
                  '$vuetify.learnerManagement.importUsersDialog.dragFile'
                )
              }}
            </a>
            {{
              $vuetify.lang.t(
                '$vuetify.learnerManagement.importUsersDialog.dragFile2'
              )
            }}
          </v-col>
        </v-row>
      </v-card-text>

      <!--<el-button :loading="loading" class="full" size="mini" type="primary" >
        Browse
      </el-button>-->
    </div>
    <div class="mt-4" v-if="file">
      <!-- <div v-for="(src, index) in imgSrc" :key="index + '_' + src"> -->
      <v-row justify="center">
        <v-col cols="2" style="justify-content: flex-start; display: flex">
          <v-avatar rounded size="60">
            <v-icon class="mx-auto" elevation="3" size="70">
              mdi-file-table-outline
            </v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="8">
          <!-- <div class="img-panel mt-auto"> -->
          <p class="mb-0 font-weight-bold">{{ file.name }}</p>
          <v-progress-linear
            class="progress mt-2 mr-4"
            :value="progressPercent"
            reactive
            rounded
            height="5"
          >
          </v-progress-linear>

          <!-- <p class="mb-0">{{ progressPercent }}%</p> -->
          <!-- </div> -->
        </v-col>
        <v-col cols="1" style="justify-content: center; display: inherit">
          <p class="mb-0 mt-5">{{ progressPercent }}%</p>
        </v-col>
        <!-- <v-col cols="8" :lg="8" :md="8" :sm="8"> -->

        <!-- <v-row v-if="showUploadPercent">
              <v-col cols="12" class="d-flex py-0">
                <v-progress-linear
                  class="progress mt-2 mr-4"
                  :value="src.progressPercent"
                  reactive
                  height="10"
                ></v-progress-linear>
                <p class="mb-0">{{ src.progressPercent }}%</p>
              </v-col>
            </v-row> -->
        <!-- </v-col> -->
      </v-row>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function, // eslint-disable-line
    isOpen: Boolean,
    excelType: String,
    //exacel type => user, exam, learner
  },
  data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: null,
      },
      file: null,
      progressPercent: 0,
      user: [],
      headers: [],
      sheet: null,
    };
  },
  watch: {
    isOpen(value) {
      if (value == false) {
        this.file = null;
        this.progressPercent = 0;
      }
    },
  },
  methods: {
    timer() {
      console.log('timer -> excelType', this.excelType);
      let vm = this;
      let setIntervalRef = setInterval(function () {
        vm.progressPercent += 5;
        if (vm.progressPercent == 100) {
          clearInterval(setIntervalRef);
          // vm.completed = true;
        }
      }, 100);
    },

    generateData({ header, results }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.onSuccess && this.onSuccess(this.excelData, this.user);
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error('Only support uploading one file!');
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$message.error(
          'Only supports upload .xlsx, .xls, .csv suffix files'
        );
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (!rawFile) return;

      this.upload(rawFile);
    },
    upload(rawFile) {
      this.progressPercent = 0;
      this.timer();
      this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

      if (!this.beforeUpload) {
        this.file = rawFile;
        this.readerData(rawFile);
        return;
      }
      const before = this.beforeUpload(rawFile);
      if (before) {
        this.file = rawFile;

        this.readerData(rawFile);
      } else {
        this.file = '';
      }
    },

    readerData(rawFile) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          this.sheet = worksheet;
          const header = this.getHeaderRow(worksheet);
          // if (this.excelType == 'user') {
          //   this.getDataCol(worksheet);
          // }
          const results = XLSX.utils.sheet_to_json(worksheet);
          this.generateData({ header, results });
          this.loading = false;
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);

      let C;
      const R = range.s.r;
      /* start in the first row */

      for (C = range.s.c; C <= range.e.c; ++C) {
        console.log('getHeaderRow -> C', C);
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

        if (hdr.includes('*')) {
          let header_sub_str = hdr.slice(0, -1);
          headers.push(header_sub_str);
        } else {
          headers.push(hdr);
        }
      }
      console.log('getHeaderRow -> headers', headers);
      //generate header
      if (this.excelType == 'user') {
        if (headers[5] == 'password') {
          this.headers = {
            prefix: headers[0],
            firstname: headers[1],
            lastname: headers[2],
            gender: headers[3],
            username: headers[4],
            password: headers[5],
            contactEmail: headers[6],
            note: headers[7],
            usergroups: headers[8],
          };
        } else {
          this.headers = {
            prefix: headers[0],
            firstname: headers[1],
            lastname: headers[2],
            gender: headers[3],
            username: headers[4],
            contactEmail: headers[5],
            note: headers[6],
            usergroups: headers[7],
          };
        }

        console.log('getHeaderRow -> this.headers ', this.headers);
        this.getDataCol(this.sheet);
      }

      return headers;
    },
    getDataCol(sheet) {
      this.user = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      let R;
      console.log('getDataCol -> this.headers', this.headers);
      for (R = 1; R <= range.e.r; ++R) {
        const users = [];
        for (C = 0; C <= range.e.c; ++C) {
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
          let usr = '';
          if (cell && cell.t) usr = XLSX.utils.format_cell(cell);

          users.push(usr);
        }
        //generate data table and send back to caller
        if (!this.headers.password) {
          this.user.push({
            prefix: users[0],
            firstname: users[1],
            lastname: users[2],
            gender: users[3],
            username: users[4],
            contactEmail: users[5],
            note: users[6],
            usergroups: users[7],
          });
        } else {
          this.user.push({
            prefix: users[0],
            firstname: users[1],
            lastname: users[2],
            gender: users[3],
            username: users[4],
            password: users[5],
            contactEmail: users[6],
            note: users[7],
            usergroups: users[8],
          });
        }
      }
      console.log('getDataCol -> this.user', this.user);
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
  },
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}
.drop {
  border: 4px dashed #bbb;
  width: 100%;
  height: 200px;
  /* line-height: 160px; */
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
  display: flex;
}
</style>